var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineHappyemoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22 12c0-5.93 4.83-10.75 10.75-10.75S22.72 6.07 22.72 12 17.9 22.75 11.97 22.75C6.05 22.75 1.22 17.93 1.22 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25-4.15-9.25-9.25-9.25S2.72 6.9 2.72 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 16.43a.742.742 0 0 1 .19-1.04c.34-.24.81-.15 1.04.19A5.098 5.098 0 0 0 12 17.76c1.66 0 3.22-.81 4.17-2.18.24-.34.7-.42 1.04-.19.34.24.42.7.19 1.04a6.576 6.576 0 0 1-5.4 2.82c-2.15 0-4.17-1.05-5.4-2.82z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHappyemoji);
export default __webpack_public_path__ + "static/media/vuesax-outline-happyemoji.38d575da69deea8e9897e630a6475647.svg";
export { ForwardRef as ReactComponent };